import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=d45a4bba&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"
import style0 from "./OrderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=d45a4bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45a4bba",
  null
  
)

export default component.exports